module.exports = __webpack_public_path__ + "static/img/drawing.9e68c58c.png";